<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs v-model:activeKey="activeKey" destroyInactiveTabPane>
        <a-tab-pane :key="1" tab="门店首页设置" forceRender>
          <homeSet></homeSet>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="门店常用功能设置">
          <homeUsedSet></homeUsedSet>
        </a-tab-pane>
        <a-tab-pane :key="3" tab="登录页设置">
          <loginSet></loginSet>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref } from "vue";
import homeSet from './components/homeSet';
import homeUsedSet from './components/homeUsedSet';
import loginSet from './components/loginSet';
export default {
  components: {homeSet,homeUsedSet,loginSet },
  setup(props) {
    const activeKey = ref(1)
    return {
      activeKey
    };
  },
};
</script>